import React, { useState, useEffect } from "react";
import { setTitle } from "../../helpers/MetaTag";
import Button from "../../components/form/Button";
import Image from "../../components/elements/Image";
import ButtonFile from "../../components/form/ButtonFile";
import Textarea from "../../components/form/Textarea";
import toastr from "toastr";
import { useNavigate } from "react-router";

import { allowedImageExtensions, languages } from "../../helpers";
import { postData } from "../../services/api";

import { useTranslation } from "react-i18next";

const ManageAbout = () => {
  setTitle("Succession Planning Software for your Business with Succession Now | About Us");
  const { t } = useTranslation();
  const allLang = languages();
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState(0);
  const [details, setDetails] = useState({});
  //const [name, setName] = useState("");
  const [image, setImage] = useState("");
  const [showLogo, setShowLogo] = useState(null);
  const [description, setDescription] = useState({});
  //sconst [subTitle, setSubTitle] = useState("");
  const [isManage, setIsManage] = useState(false);
  const [isCancel, setIsCancel] = useState(false);
  const [id, setId] = useState("");
  //const [services, setServices] = useState([]);

  useEffect(() => {
    // About details
    const loadDetails = async () => {
      try {
        const result = await postData("about-us/details", {});
        if (result.data) {
          setDetails(result.data);
          // setServices(
          //   result.data.ambition || [
          //     {
          //       title: "",
          //       icon: "",
          //       content: "",
          //     },
          //   ]
          // );
        }
      } catch (err) {
        console.log(err.message);
      }
    };
    loadDetails();
  }, []);

  useEffect(() => {
    //setName(details?.name);
    //setSubTitle(details?.sub_title);
    setDescription(details?.description);
    setShowLogo(details?.image);
    setId(details?._id);
  }, [details]);

  const onCancel = async (e) => {
    setIsCancel(true);
    if (id) {
      // setName(details?.name);
      // setSubTitle(details?.sub_title);
      setDescription(details?.description);
    } else {
      // setName("");
      setDescription("");
      // setSubTitle("");
      //setShowLogo("/male-placeholder-image.jpeg");
    }
    setIsCancel(false);
  };

  const onSubmit = async (e) => {
    setIsManage(true);
    e.preventDefault();
    const formData = new FormData();
    // formData.append("name", name);
    // formData.append("sub_title", subTitle);
    for (const key in description) {
      if (Object.hasOwnProperty.call(description, key)) {
        formData.append("description[" + key + "]", description[key]);
      }
    }
    formData.append("image", image);
    //formData.append("ambition", services);
    try {
      let path = "";
      let payload = "";
      if (id) {
        path = "about-us/update";
        formData.append("id", id);
        payload = formData;
      } else {
        path = "about-us/create";
        payload = formData;
      }
      const result = await postData(path, payload);
      if (result.status && result.status === 200) {
        toastr.success(result.message);
        setIsManage(false);
        return navigate("/about");
      } else {
        toastr.error(result.message);
        setIsManage(false);
      }
    } catch (error) {
      toastr.error(error.message);
      setIsManage(false);
    }
  };

  const onImgChange = (e) => {
    if (e.target.files[0]) {
      const ext = e.target.files[0].type.split("/")[1];
      if (![...allowedImageExtensions()].includes(ext)) {
        toastr.error("Please upload a valid image");
      } else {
        var output = document.getElementById("image1");
        output.src = URL.createObjectURL(e.target.files[0]);
        output.onload = function () {
          URL.revokeObjectURL(output.src); // free memory
        };
        setImage(e.target.files[0]);
      }
    }
  };

  // const addRow = async () => {
  //   setServices((services) => [
  //     ...services,
  //     {
  //       title: "",
  //       icon: "",
  //       content: "",
  //     },
  //   ]);
  // };

  // const removeRow = async (index) => {
  //   setServices((services) => services.filter((item, i) => i !== index));
  // };

  // const handelUpdate = async (type, val, index) => {
  //   if (type === "title") {
  //     setServices((services) =>
  //       services.map((item, i) => {
  //         if (i === index) {
  //           return {
  //             ...item,
  //             title: val,
  //           };
  //         } else {
  //           return item;
  //         }
  //       })
  //     );
  //   } else if (type === "icon") {
  //     setServices((services) =>
  //       services.map((item, i) => {
  //         if (i === index) {
  //           return {
  //             ...item,
  //             icon: val,
  //           };
  //         } else {
  //           return item;
  //         }
  //       })
  //     );
  //   } else if (type === "content") {
  //     setServices((services) =>
  //       services.map((item, i) => {
  //         if (i === index) {
  //           return {
  //             ...item,
  //             content: val,
  //           };
  //         } else {
  //           return item;
  //         }
  //       })
  //     );
  //   }
  // };

  return (
    <div className="border bg-white border-gray-200 p-4 shadow-md rounded-xl ">
      <div className="relative flex justify-between items-center mb-3 flex-wrap sm:flex-nowrap gap-y-4">
        <div className="text-2xl font-bold">{t("about_us")}</div>
      </div>
      <div className="grid grid-cols-12 gap-4">
          <div className="col-span-12 lg:col-span-3 border-r border-slate-200">
            <div className="p-2 2xl:p-4">
              <div className="py-6 px-6 flex flex-col space-y-2 relative">
                <div className="relative group w-full aspect-1 border-2  mx-auto overflow-hidden rounded-full border-dark-teal-500">
                  <Image src={showLogo} alt={"Admin"} width={"100%"} height={"100%"} effect={"blur"} classes={"object-cover"} id={"image1"} />
                </div>
              </div>
              <div className="divide-x divide-slate-200 flex items-center justify-center rounded-b border-t border-slate-200 pt-5">
                <ButtonFile buttonType={"button"} buttonIcon={"fa-light fa-image"} buttonIconPosition={"left"} buttonLabel={t("upload_image")} functions={onImgChange} accepts={"image/*"} />
              </div>
            </div>
          </div>
          <div className="col-span-12 lg:col-span-9 flex flex-col">
                <div className="space-y-4">
                  {/* <div className="grid grid-cols-1 sm:grid-cols-12 gap-4">
                    <div className="relative col-span-12 sm:col-span-6">
                      <Input label={t("name")} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_name")} inputValue={name} setInput={setName} />
                    </div>
                    <div className="relative col-span-12 sm:col-span-6">
                      <Input label={t("name")} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_name")} inputValue={subTitle} setInput={setSubTitle} />
                    </div>
                  </div> */}
                  <ul className="flex flex-wrap text-sm font-medium text-center border-b border-slate-200 gap-4" id="default-tab" data-tabs-toggle="#default-tab-content" role="tablist">
                    {allLang &&
                      allLang.length > 0 &&
                      allLang.map((item, index) => (
                        <li className="" role="presentation" key={index}>
                          <button className={"inline-block px-4 py-2 rounded-t-lg text-sm font-medium text-center" + (index === activeTab ? " bg-teal-100 text-teal-600" : " text-gray-500")} id={"tab-" + item?.value} data-tabs-target={"#" + item?.value} type="button" role="tab" aria-controls={item?.value} aria-selected="false" onClick={() => setActiveTab(index)}>
                            {item?.label}
                          </button>
                        </li>
                      ))}
                  </ul>
                  <div id="default-tab-content">
                    {allLang &&
                      allLang.length > 0 &&
                      allLang.map((item, index) => (
                        <div className={index === activeTab ? "show" : "hidden"} id={item?.value} role="tabpanel" aria-labelledby={"tab-" + item?.value} key={index}>
                          <div className="flex items-start gap-4">
                            <div className="relative w-full">
                              <Textarea
                                label={t("description")}
                                labelClasses={"!text-xs"}
                                inputClasses={"!h-40 lg:!h-96"}
                                inputValue={description?.[item?.value]}
                                inputPlaceholder={t("enter_description")}
                                setTextarea={(val) =>
                                  setDescription({
                                    ...description,
                                    [item?.value]: val,
                                  })
                                }
                              />
                            </div>
                          </div>
                        </div>
                      ))}
                  </div>
                  <hr />
                  {/* <div className="text-lg font-bold">Services</div>
                  <div className="relative !mt-0">
                    {services.map((item, key) => {
                      return (
                        <div className="py-2 space-y-2" key={key}>
                          <div className="grid sm:grid-cols-12 gap-4 relative pr-8 sm:pr-10 border-t border-slate-50 shadow-md p-3 rounded-md">
                            <div className="relative col-span-12 sm:col-span-6">
                              <Input label={""} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_title")} inputValue={item?.title} setInput={(val) => handelUpdate("title", val, key)} />
                            </div>
                            <div className="relative col-span-12 sm:col-span-6">
                              <Input label={""} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_icon")} inputValue={item?.icon} setInput={(val) => handelUpdate("icon", val, key)} />
                            </div>
                            {key === 0 ? <Button buttonIcon={"fa-light fa-plus"} buttonIconPosition={"left"} buttonClasses={"!h-6 !w-6 !min-w-[24px] !text-sm !p-0 absolute bottom-3 right-1"} buttonType={"button"} functions={(e) => addRow()} buttonHasLink={false} /> : <Button buttonIcon={"fa-light fa-minus"} buttonIconPosition={"left"} buttonClasses={"!h-6 !w-6 !min-w-[24px] !text-sm !p-0 !bg-rose-500 absolute bottom-3 right-1"} buttonType={"button"} functions={(e) => removeRow(key)} buttonHasLink={false} />}
                            <div className="relative col-span-12">
                            <div className="relative w-full">
                              <Input label={""} labelClasses={"!text-xs"} inputType={"text"} inputPlaceholder={t("enter_text")} inputValue={item?.content} setInput={(val) => handelUpdate("content", val, key)} />
                            </div>
                            
                          </div>
                          </div>
                          
                        </div>
                      );
                    })}
                  </div> */}
                </div>
                <div className="flex justify-end gap-4 mt-5">
                  <Button buttonLabelClasses="" buttonType={"button"} buttonIcon={isCancel ? "fa-light fa-spinner fa-spin" : "fa-light fa-times"} buttonIconPosition={"left"} buttonLabel={t("cancel")} buttonClasses={"!bg-slate-200 !text-slate-600 border border-slate-300"} functions={onCancel} buttonHasLink={false} buttonDisabled={isCancel} />
                  <Button buttonClasses="" buttonLabelClasses="" buttonType={"button"} buttonIcon={isManage ? "fa-light fa-spinner fa-spin" : "fa-light fa-floppy-disk"} buttonIconPosition={"left"} buttonLabel={t("save")} functions={onSubmit} buttonHasLink={false} buttonDisabled={isManage} />
                </div>
          </div>
      </div>
    </div>
  );
};

export default ManageAbout;
